<style lang='scss' scoped>
.myCloud {
  position: relative;
  .sort {
    position: fixed;
    top: 1.63rem;
    width: calc(100% - 0.64rem);
    background: #fff;
    z-index: 999;
    font-size: 0.28rem;
    height: 0.74rem;
    background-color: #f7f7f7;
    line-height: 0.74rem;
    border-top: 1px solid #ebebeb;
    border-bottom: 1px solid #ebebeb;
    padding: 0rem 0.32rem;
    .sort_boxL {
      height: 0.74rem;
      line-height: 0.74rem;
      img {
        width: 0.22rem;
        vertical-align: middle;
      }
      div {
        margin-left: 0.1rem;
      }
    }

    .sort_boxR {
      height: 0.74rem;
      line-height: 0.74rem;
      img {
        width: 0.28rem;
        vertical-align: middle;
      }
      div {
        color: #666;
        margin-top: 0.02rem;
        margin-left: 0.1rem;
      }
    }
  }
  .codeData {
    margin-top: 2.41rem;
    padding-bottom: 2rem;
    li {
      margin-top: 0.3rem;
      margin-left: 0.26rem;
      width: 3.32rem;
      height: 4.18rem;
      border: 1px solid #e6e9ed;
      position: relative;
      .selectImg {
        position: absolute;
        top: 0.2rem;
        left: 0.2rem;
        img {
          width: 0.36rem;
        }
      }
      .img_box {
        width: 2.92rem;
        height: 2.48rem;
        line-height: 2.48rem;
        border-top-right-radius: 0.05rem;
        border-top-left-radius: 0.05rem;
        padding: 0.2rem;
        text-align: center;
        background-color: #e6e9ed;
        img {
          vertical-align: middle;
          border-radius: 0.1rem;
          max-width: 2.92rem;
          max-height: 2.48rem;
        }
      }
      .codeInfo {
        padding: 0.2rem 0.32rem 0.24rem 0.32rem;
        p {
          font-size: 0.28rem;
          line-height: 0.28rem;
          margin-bottom: 0.2rem;
        }
        div.m_clearLR {
          font-size: 0.24rem;
          line-height: 0.24rem;
          color: #9a9a9a;
        }
      }
    }
  }
  .selectSort {
    position: fixed;
    top: 2.41rem;
    z-index: 999;
  }
  .codeList {
    margin: 2.46rem 0 0 0.32rem;
    li {
      padding-top: 0.15rem;
      display: flex;
      & > img {
        width: 1.16rem;
        height: 1.16rem;
      }
      .info {
        border-bottom: 1px solid #e6e6e6;
        margin-top: 0.25rem;
        margin-left: 0.25rem;
        height: 1.05rem;
        flex: 1;
        img {
          margin-top: 0.15rem;
          margin-right: 0.32rem;
          width: 0.36rem;
        }
        p {
          font-size: 0.28rem;
          color: #333;
          line-height: 0.28rem;
          margin-bottom: 0.15rem;
        }
        span {
          color: #9a9a9a;
          font-size: 0.24rem;
        }
      }
    }
  }
  .editBottom {
    position: fixed;
    bottom: 0px;
    width: 100%;
    border-top: 1px solid #ebebeb;
    z-index: 999;
  }
  .noData {
    text-align: center;
    margin-top: 0.5rem;
    color: #666;
    font-size: 0.28rem;
    padding-bottom: 1.5rem;
  }
  .noLogin {
    width: 100%;
    padding-top: 1.07rem;
    text-align: center;
    img {
      width: 3.5rem;
    }
    .text {
      font-size: 0.28rem;
      color: #666666;
      margin-top: 0.3rem;
    }
    .feedback {
      margin-top: 0.6rem;
      width: 2.25rem;
      height: 0.72rem;
      line-height: 0.72rem;
      font-size: 0.3rem;
      text-align: center;
      color: #0497ff;
      border: 1px solid #0497ff;
      border-radius: 0.05rem;
    }
  }
}
</style>
<template>
  <div class="myCloud">
    <div class="sort m_clearLR">
      <div class="sort_boxL m_clearLR m_floatL" @click="openSort">
        <img
          :src="$route.query.token?require('@/../public/images/small.png'):require('@/../public/images/small.png')"
          alt
          class
        />
        <div class="m_floatR">按名称排序</div>
      </div>
      <div class="sort_boxR m_clearLR m_floatR" v-if="changeList" @click="changeStyle">
        <img src="@/../public/images/list.png" alt class />
        <div class="m_floatR">大图</div>
      </div>
      <div class="sort_boxR m_clearLR m_floatR" v-else @click="changeStyle">
        <img src="@/../public/images/list_2.png" alt class />
        <div class="m_floatR">列表</div>
      </div>
    </div>
    <selectSort class="selectSort" v-show="showSort" @selectSort="selectSort"></selectSort>
    <ul class="codeData m_clearLR" v-if="changeList">
      <li class="m_floatL" v-for="(item,index) in cloudData" :key="index" @click="selectTag(item)">
        <div class="selectImg" v-show="isEdit" @click="selectList(item)">
          <img v-if="!item.select" class="editImg" src="@/../public/images/select.png" alt />
          <img v-else class="editImg" src="@/../public/images/selected.png" alt />
        </div>
        <div class="img_box">
          <img :src="item.img" alt />
        </div>
        <div class="codeInfo">
          <p>{{item.name}}</p>
          <div class="m_clearLR">
            <div class="date m_floatL">{{item.add_time|partFilter('')}}</div>
            <div class="size m_floatR">{{item.fileSize}}</div>
          </div>
        </div>
      </li>
    </ul>
    <ul class="codeList" v-else>
      <li class="m_clearLR" v-for="(item,index) in cloudData" :key="index" @click="selectTag(item)">
        <img class="m_floatL" :src="item.img" />
        <div class="m_floatL info">
          <div class="m_floatL">
            <p>{{item.name}}</p>
            <span>{{item.add_time|partFilter('')}}</span>
            <span>{{item.fileSize}}</span>
          </div>
          <div class="m_floatR" v-show="isEdit" @click="selectList(item)">
            <img v-if="!item.select" class="editImg" src="@/../public/images/select.png" alt />
            <img v-else class="editImg" src="@/../public/images/selected.png" alt />
          </div>
        </div>
      </li>
    </ul>
    <div v-show="noLogin" class="noLogin">
      <img src="@/../public/images/noLogin.png" />
      <div class="text">当前功能需登录后才可使用</div>
      <div class="feedback m_tran50" @click="toLogin">立即登录</div>
    </div>
    <div class="noData" v-show="!noLogin">没有更多数据了</div>
    <editBottom
      v-show="isEdit"
      class="editBottom"
      @selectDelete="selectDelete"
      @selectAll="selectAll"
      @selectRename="selectRename"
    ></editBottom>
    <messageBox @confirm="confromDelete" @cancel="cancelDelete" v-show="isDelete"></messageBox>
    <rename @confirm="confromRename" :name="name" @cancel="cancelRename" v-show="isRename"></rename>
  </div>
</template>
<script>
import selectSort from '@/components/selectSort';
import editBottom from '@/components/editBottom';
import rename from '@/components/rename';
import messageBox from '@/components/messageBox';
import { cloundList, deleteClound, updateClound } from '@/api/api';
var bridge = {
  default: this,
  call: function (b, a, c) {
    var e = '';
    'function' == typeof a && ((c = a), (a = {}));
    a = { data: void 0 === a ? null : a };
    if ('function' == typeof c) {
      var g = 'dscb' + window.dscb++;
      window[g] = c;
      a._dscbstub = g;
    }
    a = JSON.stringify(a);
    if (window._dsbridge) e = _dsbridge.call(b, a);
    else if (window._dswk || -1 != navigator.userAgent.indexOf('_dsbridge'))
      e = prompt('_dsbridge=' + b, a);
    return JSON.parse(e || '{}').data;
  },
  register: function (b, a, c) {
    c = c ? window._dsaf : window._dsf;
    window._dsInit ||
      ((window._dsInit = !0),
      setTimeout(function () {
        bridge.call('_dsb.dsinit');
      }, 0));
    'object' == typeof a ? (c._obs[b] = a) : (c[b] = a);
  },
  registerAsyn: function (b, a) {
    this.register(b, a, !0);
  },
  hasNativeMethod: function (b, a) {
    return this.call('_dsb.hasNativeMethod', { name: b, type: a || 'all' });
  },
  disableJavascriptDialogBlock: function (b) {
    this.call('_dsb.disableJavascriptDialogBlock', { disable: !1 !== b });
  },
};
!(function () {
  if (!window._dsf) {
    var b = {
        _dsf: { _obs: {} },
        _dsaf: { _obs: {} },
        dscb: 0,
        dsBridge: bridge,
        close: function () {
          bridge.call('_dsb.closePage');
        },
        _handleMessageFromNative: function (a) {
          var e = JSON.parse(a.data),
            b = { id: a.callbackId, complete: !0 },
            c = this._dsf[a.method],
            d = this._dsaf[a.method],
            h = function (a, c) {
              b.data = a.apply(c, e);
              bridge.call('_dsb.returnValue', b);
            },
            k = function (a, c) {
              e.push(function (a, c) {
                b.data = a;
                b.complete = !1 !== c;
                bridge.call('_dsb.returnValue', b);
              });
              a.apply(c, e);
            };
          if (c) h(c, this._dsf);
          else if (d) k(d, this._dsaf);
          else if (((c = a.method.split('.')), !(2 > c.length))) {
            a = c.pop();
            var c = c.join('.'),
              d = this._dsf._obs,
              d = d[c] || {},
              f = d[a];
            f && 'function' == typeof f
              ? h(f, d)
              : ((d = this._dsaf._obs),
                (d = d[c] || {}),
                (f = d[a]) && 'function' == typeof f && k(f, d));
          }
        },
      },
      a;
    for (a in b) window[a] = b[a];
    bridge.register('_hasJavascriptMethod', function (a, b) {
      b = a.split('.');
      if (2 > b.length) return !(!_dsf[b] && !_dsaf[b]);
      a = b.pop();
      b = b.join('.');
      return (b = _dsf._obs[b] || _dsaf._obs[b]) && !!b[a];
    });
  }
})();
export default {
  data() {
    return {
      currentIndex: 0,
      showSort: false,
      page_size: 100,
      page: 1,
      cloudData: [],
      isDelete: false,
      sort: 'name',
      changeList: true,
      noLogin: false,
      isEdit: false,
      isRename: false,
      testData: '123',
      name: '',
      isAll: false,
      datas: [
        {
          id: 1477,
          name: '猪',
          description: null,
          iconPath:
            'iconImages/猪.png',
          iconType: 93,
          createTime: 1544154065000,
        },
        {
          id: 1478,
          name: '兔',
          description: null,
          iconPath:
            'iconImages/兔.png',
          iconType: 93,
          createTime: 1544154065000,
        },
        {
          id: 1467,
          name: '狗',
          description: null,
          iconPath:
            'iconImages/狗.png',
          iconType: 93,
          createTime: 1544154064000,
        },
        {
          id: 1468,
          name: '虎',
          description: null,
          iconPath:
            'iconImages/虎.png',
          iconType: 93,
          createTime: 1544154064000,
        },
        {
          id: 1469,
          name: '鸡',
          description: null,
          iconPath:
            'iconImages/鸡.png',
          iconType: 93,
          createTime: 1544154064000,
        },
        {
          id: 1470,
          name: '牛',
          description: null,
          iconPath:
            'iconImages/牛.png',
          iconType: 93,
          createTime: 1544154064000,
        },
        {
          id: 1471,
          name: '猴',
          description: null,
          iconPath:
            'iconImages/猴.png',
          iconType: 93,
          createTime: 1544154064000,
        },
        {
          id: 1472,
          name: '马',
          description: null,
          iconPath:
            'iconImages/马.png',
          iconType: 93,
          createTime: 1544154064000,
        },
        {
          id: 1473,
          name: '蛇',
          description: null,
          iconPath:
            'iconImages/蛇.png',
          iconType: 93,
          createTime: 1544154064000,
        },
        {
          id: 1474,
          name: '鼠',
          description: null,
          iconPath:
            'iconImages/鼠.png',
          iconType: 93,
          createTime: 1544154064000,
        },
        {
          id: 1475,
          name: '龙',
          description: null,
          iconPath:
            'iconImages/龙.png',
          iconType: 93,
          createTime: 1544154064000,
        },
        {
          id: 1476,
          name: '羊',
          description: null,
          iconPath:
            'iconImages/羊.png',
          iconType: 93,
          createTime: 1544154064000,
        },
      ],
    };
  },
  components: {
    selectSort,
    editBottom,
    messageBox,
    rename,
  },
  created() {
    if (this.$route.query.isEdit) {
      this.isEdit = this.$route.query.isEdit;
    }
    this.getData();
    this.test3();
  },
  filters: {
    //转化时间年月日
    partFilter: function (value, type) {
      if (!value) return '';
      var time = value.split('T')[0];
      var year = time.split('-');
      value = year[0] + '-' + year[1] + '-' + year[2].split(' ')[0];
      return value;
    },
  },
  methods: {
    toLogin() {
      dsBridge.call('Dlabel.toLogin', '');
    },
    selectTag(item) {
      if (!this.$route.query.isEdit) {
        dsBridge.call('Dlabel.getUserTemplate', {
          id: item.id,
          name: item.name,
          file: item.file,
        });
      }
    },
    cancelDelete() {
      this.isDelete = false;
    },
    cancelRename() {
      this.isRename = false;
    },
    selectDelete() {
      this.isDelete = true;
    },
    selectRename() {
      var temp = [];
      this.cloudData.forEach((item) => {
        if (item.select) {
          temp.push(item);
        }
      });
      if (temp.length != 1) {
        this.$toast('只能修改单个标签名');
        return;
      }
      this.name = temp[0].name;
      this.isRename = true;
    },
    selectAll() {
      if (!this.isAll) {
        this.cloudData.forEach((item) => {
          item.select = true;
        });
        this.isAll = true;
      } else {
        this.cloudData.forEach((item) => {
          item.select = false;
        });
        this.isAll = false;
      }
    },
    confromRename(name) {
      this.cloudData.forEach((item) => {
        if (item.select) {
          var formData = new FormData();
          formData.append('name', name);
          updateClound(item.id, formData).then((res) => {
            this.$toast('修改成功');
            this.isRename = false;
            this.getData();
          });
        }
      });
    },

    confromDelete() {
      var temp = [];
      this.cloudData.forEach((item) => {
        if (item.select) {
          temp.push(item);
        }
      });
      temp.forEach((item, index) => {
        ((i) => {
          deleteClound(item.id).then((res) => {
            if (i == temp.length - 1) {
              this.$toast('删除成功');
              this.isDelete = false;
              this.getData();
            }
          });
        })(index);
      });
    },
    selectList(item) {
      item.select = !item.select;
    },
    changeStyle() {
      this.changeList = !this.changeList;
    },
    getData() {
      this.$indicator.open({
        text: 'Loading...',
      });
      cloundList({
        page_size: this.page_size,
        page: this.page,
        ordering: this.sort,
      })
        .then((res) => {
          if (res.data.status == 401) {
            this.noLogin = true;
          }
          var temp = res.data.data.results;

          temp.forEach((item) => {
            item.select = false;
          });
          this.cloudData = temp;
          this.$indicator.close();
        })
        .catch((error) => {
          this.$indicator.close();
        });
    },
    openSort() {
      this.showSort = true;
    },
    selectSort(text) {
      this.sort = text;
      this.getData();
      this.showSort = false;
    },
    test4() {
      alert(this.testData);
    },
    test3() {
      test2(this.test4, 'myTest');
    },
  },
};
var testArr = {};
function test2(test1, name) {
  testArr[name] = test1;
}
function search(t) {
  console.log(testArr);
  testArr[t]();
}
setTimeout(() => {
  search('myTest');
}, 5000);
</script>



